import styled from '@emotion/styled';
import { rem } from 'polished';
import { fontWeights, mixins, spaces, text, colors } from 'atupri-component-library/lib/core/styles/theme/default';

export const MultipleGroupContainer = styled.div`
    position: relative;
    width: 100%;

    ${mixins.responsiveStyles({
        'padding-top': {
            zero: `${rem(spaces.delta)}`,
            medium: `${rem(spaces.theta)}`,
            wide: `${rem(spaces.theta)}`,
        },
        'margin-top': {
            zero: `0`,
            medium: `${rem(spaces.delta)}`,
            wide: `${rem(spaces.delta)}`,
        },
    })}

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 1px;
        background-color: ${colors.grey300};
    }
`;

export const MultipleGroupEnumeration = styled.div`
    ${text.p3}

    ${mixins.responsiveStyles({
        margin: {
            zero: `0 0 ${rem(spaces.delta)}`,
            medium: `0 0 ${rem(spaces.epsilon)}`,
        },
    })}

  > span {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background-color: ${colors.blue300};
        border-radius: 100%;
        font-size: ${rem(spaces.delta)};
        line-height: 1;
        font-weight: ${fontWeights.semibold};
        color: ${colors.primary};
        height: ${rem(spaces.zeta)};
        width: ${rem(spaces.zeta)};
        margin: 0 ${rem(14)} 0 0;
    }
`;
